import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import UserMenu from './UserMenu';
import MarketMenu from './MarketMenu';
import EnvironmentName from '../Internationalize/EnvironmentName';
import { useHistory, useLocation } from 'react-router-dom';
import Search from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
  appBarRoot: {
    transition: 'background-color 0.12s linear',
    backgroundColor: theme.palette.primary.main
  },
  flex: {
    display: 'flex',
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  search: {
    marginLeft: '15px',
    cursor: 'pointer'
  }
}));

export function AppBar({ toggleNavDrawer }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { formatMessage } = useIntl();

  return (
    <MuiAppBar position="static" classes={{ root: classes.appBarRoot }}>
      <Toolbar>
        <Tooltip title={formatMessage({ id: 'appBar.menuIconTooltip' })}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            aria-label={formatMessage({ id: 'appBar.menu' })}
            onClick={() => setTimeout(toggleNavDrawer, 100)}
          >
            <MenuIcon />
          </IconButton>
        </Tooltip>
        <div className={classes.flex}>
          <Typography variant="h6" color="inherit" noWrap>
            <EnvironmentName />
          </Typography>
          {location.pathname === '/' && (
            <Search
              htmlColor="white"
              fontSize="large"
              className={classes.search}
              onClick={() => {
                history.push('/search');
              }}
            />
          )}
        </div>

        <MarketMenu />
        <UserMenu />
      </Toolbar>
    </MuiAppBar>
  );
}

AppBar.propTypes = {
  toggleNavDrawer: PropTypes.func.isRequired
};

export default AppBar;
